// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__sAAbJ","features__featurewrap":"Features_features__featurewrap__KIon6","features__feature":"Features_features__feature__K4V04"};